import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "../styles/Results.css"; // استيراد CSS الجديد

const Pagination = ({
  recordsPerPage,
  totalRecords,
  currentPage,
  paginate,
}) => {
  const pageNumbers = [];
  const totalPages = Math.ceil(totalRecords / recordsPerPage);

  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  if (totalPages <= 1) return null; // لا داعي للpagination

  const handlePrev = () => {
    if (currentPage > 1) paginate(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) paginate(currentPage + 1);
  };

  return (
    <nav aria-label="Pagination">
      <ul className="pagination">
        <li className={`page-item${currentPage === 1 ? " disabled" : ""}`}>
          <button
            onClick={handlePrev}
            className="page-link"
            aria-label="الصفحة السابقة"
            style={{ background: "#ea9b56", color: "#fff" }}
            disabled={currentPage === 1}
          >
            <FaChevronRight />
          </button>
        </li>
        {pageNumbers.map((number) => (
          <li
            key={number}
            className={`page-item${currentPage === number ? " active" : ""}`}
          >
            <button
              onClick={() => paginate(number)}
              className="page-link"
              style={
                currentPage === number
                  ? { background: "#7EBFE9", color: "#fff", fontWeight: "bold" }
                  : {}
              }
            >
              {number}
            </button>
          </li>
        ))}
        <li
          className={`page-item${
            currentPage === totalPages ? " disabled" : ""
          }`}
        >
          <button
            onClick={handleNext}
            className="page-link"
            aria-label="الصفحة التالية"
            style={{ background: "#ea9b56", color: "#fff" }}
            disabled={currentPage === totalPages}
          >
            <FaChevronLeft />
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
